(function componentForm($, Adzuki)
{
	'use strict';

	var form = {
		name: 'ClientImport',
	};

	$(document).ready(function _ready()
	{
		Adzuki.onload('/Clients/importClients', function _onload()
		{
			Adzuki.Form.registerForm(form);
		});
	});

	form.load = function onFormLoad()
	{
		$([
			'input[name="form_component_data[ClientImport][import_into_source]"]',
			'input[name="form_component_data[ClientImport][import_into_segment]"]',
			'input[name="form_component_data[ClientImport][set_client_status]"]',
		].join(',')).on('change', function _toggleSection() {
			$(".form-group."+$(this).parents('.radio-group').data('section')).toggleClass('hidden');
		});

		$('a.create-source, a.select-source').click(function _toggleSource(e) {
			e.preventDefault();
			$(".sources-new").toggleClass('hidden').find('input').val('');
			$(".sources-existing").toggleClass('hidden').find('select').val('');
		});

		$('a.create-segment, a.select-segment').click(function _toggleSegment(e) {
			e.preventDefault();
			$(".segments-new").toggleClass('hidden').find('input[type="text"]').val('');

			$(".segments-existing")
				.toggleClass('hidden')
				.find('select')
				.selectpicker('deselectAll');
		});

		$('a.create-status, a.select-status').click(function _toggleStatus(e) {
			e.preventDefault();
			$(".status-new").toggleClass('hidden').find('input').val('');
			$(".status-existing").toggleClass('hidden').find('select').val('');
		});
	};

}(jQuery, window.Adzuki || {}));
